export default __webpack_public_path__ + "static/media/coverES.904731ce.jpg";